





























































import { ref, createComponent, onMounted, watch, computed } from '@vue/composition-api'
import permissionCheckbox from './permissionCheckbox.vue'
import { updatePower, dirPower, DirPower } from '@/service/public'
import { getOperateLabel, FilePower } from '@/constant'
import { isEmpty, cloneDeep } from 'lodash'
export default createComponent({
    name: 'permissionEdit',
    props: {
        viewPermission: {
            type: Boolean,
            default: false,
            require: true,
        },
    },
    components: { permissionCheckbox },
    setup(props, { root }) {
        const editPermission = ref<boolean>(false)
        const outVisible = props.viewPermission
        const checkList = ref<number[]>([])
        const dirId = root.$store.state.publicStore.tableRowData.id
        const dirName = root.$store.state.publicStore.tableRowData.name
        const ancestors = root.$store.state.publicStore.fileListdata[root.$store.state.publicStore.currentDirId].ancestors
        const breadTitle = (isEmpty(ancestors) ? '' : (cloneDeep(ancestors).reverse().map(item => item.name).join('>')+'>')) + dirName
        const current = ref<number>(1)
        const size = ref<number>(10)
        const tableData = ref<DirPower[]>([])
        const currentRow = ref<DirPower>({})
        const closeOut = () => {
            root.$store.commit('publicStore/SET_IS_VIEW_PERMISSION', false)
        }
        const getDirPower = async () => {
            const res = await dirPower({ dirId, current: current.value, size: size.value })
            if (res.code === 0) {
                tableData.value = res.data
            }
        }
        const operate = row => {
            currentRow.value = row
            checkList.value = row.powers
            editPermission.value = true
        }
        const submit = async () => {
            // 不存在其它权限时，取消可见权限,存在其它权限，但无可见时，添加可见
            if(isEmpty(checkList.value) || (checkList.value.length === 1 && checkList.value[0] === FilePower['PREVIEW'])) {
                checkList.value = []
            } else {
                if(!checkList.value.includes(FilePower['PREVIEW'])) checkList.value.push(FilePower['PREVIEW'])
            }
            if(checkList.value.length === 1 && checkList.value[0] === FilePower['PREVIEW']) checkList.value = []
            const res = await updatePower({ dirId, powers: checkList.value, userIds: [currentRow.value.userId] })
            if (res.code === 0) {
                getDirPower()
            }
            editPermission.value = false
        }
        onMounted(getDirPower)
        return {
            editPermission,
            outVisible,
            dirId,
            checkList,
            closeOut,
            tableData,
            operate,
            submit,
            getOperateLabel,
            breadTitle,
        }
    },
})
